import * as React from 'react';
import {UserMenu as RAUserMenu, Logout} from 'react-admin';

export const UserMenu = () => (
  <RAUserMenu>
    <Logout />
  </RAUserMenu>
);

export default UserMenu;
